import { render, staticRenderFns } from "./HeaderBase.vue?vue&type=template&id=46d6b57a&scoped=true&"
import script from "./HeaderBase.vue?vue&type=script&lang=js&"
export * from "./HeaderBase.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBase.vue?vue&type=style&index=0&id=46d6b57a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6b57a",
  null
  
)

export default component.exports